import { createContext, ReactNode, useContext } from 'react';
import { Campaign } from '../types/commerce';
import { REFRESH_INTERVAL_MS } from '../lib/constants';
import { useApiQuery } from './useApiQuery';

const StorefrontContent = createContext<{
  campaigns: Campaign[];
  content: Record<string, string>;
}>({ campaigns: [], content: {} });

export function StorefrontContentProvider({ children }: { children: ReactNode }) {
  const campaigns = useApiQuery<Campaign[]>('/commerce/campaigns', { pollMs: REFRESH_INTERVAL_MS });
  const content = useApiQuery<Record<string, string>>('/commerce/content', { pollMs: REFRESH_INTERVAL_MS });
  return (
    <StorefrontContent.Provider
      value={{
        campaigns: campaigns.data ?? [],
        content: content.data ?? {},
      }}
    >
      {children}
    </StorefrontContent.Provider>
  );
}
export const useStorefrontContent = () => useContext(StorefrontContent);

export function instagramUrl(content: Record<string, string>): string | null {
  const value = content.instagram_url;
  if (!value || /[\\\s]/.test(value)) return null;
  try {
    const url = new URL(value);
    return url.protocol === 'https:' && url.hostname && !url.username && !url.password ? value : null;
  } catch {
    return null;
  }
}
